import { Helmet } from "react-helmet-async";

const SEO = ({
  title = "Mheshe Attorneys Inc | Attorneys, Conveyancers & Notaries",
  description = "Mheshe Attorneys Inc is a 100% Black-Women owned law firm in Gqeberha and Johannesburg, South Africa. Expert legal services in Conveyancing, Commercial Law, Notarial Services, Family Law, Corporate Governance & more. Chosen To Serve!",
  image = "https://customer-assets.emergentagent.com/job_mheshe-legal/artifacts/1xa23sin_Mheshe%20Attorneys.png",
  url = "https://mhesheattorneys.co.za",
  type = "website",
}) => {
  const siteTitle = title.includes("Mheshe") ? title : `${title} | Mheshe Attorneys Inc`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{siteTitle}</title>
      <meta name="title" content={siteTitle} />
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Mheshe Attorneys Inc" />
      <meta property="og:locale" content="en_ZA" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;
